import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import type { SelectOption } from '@rio-cloud/rio-uikit/Select';
import type { IntlShape } from 'react-intl';

import type { OrderStatus } from '#domain/Order.ts';
import type { TourStatus } from '#domain/Tour.ts';

import type { StatusDataRecord } from './StatusOrder.ts';

type FilterProps = {
    values: string[];
    onFilter: (value: string[]) => void;
    options?: SelectOption[];
    placeholder?: string;
    noItemMessage?: string;
    inputAddon?: string;
    className?: string;
    isLoading?: boolean;
    disabled?: boolean;
    useFilter?: boolean;
};
export const Filter = ({
    values,
    onFilter,
    options,
    placeholder,
    noItemMessage,
    inputAddon,
    className,
    isLoading,
    disabled,
    useFilter,
}: FilterProps) => (
    <Multiselect
        showSelectedItemIcon
        showUnselectedItemIcons
        pullRight
        value={values}
        options={options}
        dropdownClassName='max-height-none'
        onChange={e => onFilter(e)}
        placeholder={placeholder}
        noItemMessage={noItemMessage}
        inputAddon={inputAddon}
        className={className}
        isLoading={isLoading}
        disabled={disabled}
        useFilter={useFilter}
    />
);

export const getOption = (status: TourStatus | OrderStatus, statusData: StatusDataRecord, intlShape: IntlShape) => {
    return {
        id: status,
        label: intlShape.formatMessage({ id: statusData[status].id }),
        icon: (
            <span
                className={`rioglyph rioglyph-${statusData[status].icon} text-color-${statusData[status].color} text-size-16`}
            />
        ),
        selected: statusData[status].selected,
    };
};
